import moment from "moment";
import { userSelectedDate } from "../utils/func";


export const DEFAULT_CURRENCY = "₹";
export const EUROEQUALSTORUPEE = "100";
export const DATE_FORMAT = "DD  MMM, YYYY";
export const STARTDATE_FORMAT = "YYYY-MM-DD";
export const PRELOADTEAMS = "/teams?page_size=2000";
export const PRELOADTOURNAMENTS = "/tournament?page_size=200";
export const COOKIES_EXPIRY_TIME = 24 * 60 * 60;

const getCurrentDate = () => {
  const today = new Date();
  const month = today.getMonth() + 1;
  const year = today.getFullYear();
  const date = today.getDate();
  return moment(new Date(`${month}/${date}/${year}`)).format("YYYY-MM-DD");
};

export const getCookie = (c_name) => {
  var i,
    x,
    y,
    ARRcookies = document.cookie.split(";");
  for (i = 0; i < ARRcookies.length; i++) {
    x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
    y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
    x = x.replace(/^\s+|\s+$/g, "");
    if (x === c_name) {
      return unescape(y);
    }
  }
};

export const BOOKING_TICKET_STATUS_EVENT = ["COMPLETED", "PROCESSING", "POSTPONED", "CANCELLED", "FAILED"]



export const SPORTSLIST_API = "/sports?";

export const POPULAREVENT_API = `/events?popular_events=true&date_start=${getCurrentDate()}&event_status=notstarted&min_ticket_price_eur=1&tickets_available=1`;

export const UPCOMINGEVENT_API = `/events?date_start=${getCurrentDate()}&popular_events=false&event_status=notstarted&tickets_available=1&sorting=date_start ASC`;

export const POPULARTEAMS_API = `/teams?page_size=5&popular=true&event_startdate=${getCurrentDate()}`;

export const GETMORESPORTINGEVENT_API = `events?date_start=${getCurrentDate()}&popular_events=true&page_size=3&event_status=notstarted&min_ticket_price_eur=1&tickets_available=1`;

export const TEAMS_API = `/teams?page_size=2000&team_name=`;
export const POPULARCOMPETITIONS_API = `/tournament?page_size=5&date_stop=ge ${getCurrentDate()}`;
export const COMPETITIONS_API = `/tournament?date_stop=ge ${getCurrentDate()}&tournament_name=`;
export const EVENTS_API = `events?event_status=notstarted&`;

export const NOFILTEREVENTS = `events?sorting=date_start ASC&event_status=notstarted&tickets_available=1&min_ticket_price_eur=1&date_start=${getCurrentDate()}`;

export const POPULARVENUES_API = "venuesAllList?page_size=5&popular=true";
export const LOCATION_API = "/venuesAllList?venue_name=";
export const AVAILABILITY_API = "events?page_size=5&tickets_available=";
export const CITIES_API = "/allCities?page_size=694";
export const VENUES_API = "venuesAllList?page_size=687";

export const SEARCHTEAM_API = `/teams?page_size=5&sorting=official_name ASC&event_startdate=${getCurrentDate()}&team_name=`;

export const SEARCHTOURNAMENTS_API = `tournament?page_size=5&date_stop=ge ${getCurrentDate()}&tournament_name=`;

export const SEARCHVENUES_API = "venuesAllList?page_size=5&venue_name=";

export const SEARCHTICKETCATEGORIES_API =
  "categories?page_size=9999&category_name=";

export const SEARCHEVENTS_API = `events?page_size=5&date_start=${getCurrentDate()}&event_name=`;
export const SINGLEEVENT = "eventById/";
export const TICKETSBYEVENTID = `tickets?page_size=9999&ticket_status=available&face_value=gt 1&sorting=category_name ASC,ticket_id ASC,face_value ASC&stock=gt 1&event_id=`;
// export const TICKETSBYEVENTID = `tickets?page_size=9999&ticket_status=available&face_value=gt 0&stock=gt 0`

export const EVENTSCATEGORIESBYID = "categories?page_size=9999&event_id=";

export const GETVENUESVG = "get-svg-by-venusid";
export const GETVENUECSS = "get-svg-css";
export const RESERVATION_TICKET = "reservation";
export const CART_LIST = "cart-list";
export const EMPTY_CART_LIST = "clear-cart-list"
export const PAY_DETAILS_API = "reservations";
export const ADD_WATCHLIST = "/profile/addwishlist";
export const WATCHLIST_ITEM = "/profile/wishlist";
export const REMOVE_FROM_WATCHLIST = "/profile/un-wish-list-items";
export const GUEST_DATA_REQUIRENEBT = "/event/:event_id/guestdata";
export const REMOVE_RESERVATION = "/remove-reservation";
export const CHECKOUT_GUEST_DATA = "/reservations";
export const COUNTRY_LIST = "/country-list";
export const CITY_LIST = "/city-list";
export const USER_PROFILE = "/user-profile";
export const EVENT_GUEST_DATA_REQUIREMENTS = "/event";
export const CHECKOUT_PAGE = "/checkout-page-details";
export const HANDLE_RAZOR_PAY = "/create-order-event";
export const CREATE_BOOKING = "/create-event-booking";
export const GET_BOOKING_BY_ID = "get-booking-details-by-id";
export const RESERVE_AGAIN = "/regenerate-reservation";
export const GET_BOOKINGS = "/fetch-all-booking";
export const FINAL_BOOKING = "/booking-final-event";
export const CHECK_PAYMENT_STATUS = "/check-payment-status";
export const ACTIVE_RESERVATION  = "/active-reservation";
export const E_TICKET = "/e-ticket-download";
export const UPDATE_BOOKING = "/update-supplier-booked-event"
